import { ProductMasterData } from '../../../types/product_master_data/productMasterData';
import { toMap } from '../../../util/map.util';
import { TableHeader } from '../../components/Table';
import { toFilterString } from '../../../util/string.util';
import { KitTemplateColumn, KitTemplateTableSettings } from '../../../types/kit_template/kitTemplate.table';
import { KitTemplate } from '../../../types/kit_template/kitTemplate';
import DeleteIconButton from '../../icons/templates/DeleteIconButton';
import React from 'react';

export namespace KitTemplateTable {
  export const header = (
    productMasterData: Map<string, ProductMasterData>,
    settings: KitTemplateTableSettings,
    onDelete: (item: KitTemplate) => void,
  ) => {
    const wantedColumns = toMap(settings.columns, 'column');

    const columns: TableHeader<KitTemplate>[] = [];

    if (wantedColumns.has(KitTemplateColumn.name)) {
      columns.push({
        key: 'name',
        name: wantedColumns.get(KitTemplateColumn.name)?.label || '',
        text: (item: KitTemplate) => item.name,
        column: KitTemplateColumn.name,
      });
    }

    if (wantedColumns.has(KitTemplateColumn.name)) {
      columns.push({
        key: '',
        name: '',
        text: (item: KitTemplate) => <DeleteIconButton onClick={() => onDelete(item)} />,
        column: KitTemplateColumn.name,
      });
    }

    return columns.sort(
      (a: TableHeader<KitTemplate>, b: TableHeader<KitTemplate>) =>
        (wantedColumns.get(a.column || '')?.index || -1) - (wantedColumns.get(b.column || '')?.index || -1),
    );
  };

  export const filter = (
    item: KitTemplate,
    filter: string,
    productMasterData: Map<string, ProductMasterData>,
    kitTemplates: Map<string, KitTemplate>,
    settings: KitTemplateTableSettings,
  ) => {
    filter = toFilterString(filter);

    const wantedColumns = toMap(settings.columns, 'column');

    const name = toFilterString(item.name);

    if (wantedColumns.has(KitTemplateColumn.name) && name.includes(filter)) {
      return true;
    }

    return false;
  };
}
